// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "header[data-v-75a8a2c2]{background-blend-mode:multiply,normal}.title-hero[data-v-75a8a2c2]{font-size:7vw;}@media (min-width: 768px){.title-hero[data-v-75a8a2c2]{font-size:clamp(60px,4.5vw,80px)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
